import { validations } from "../form"
import OnboardingContent from "../../components/onboarding/OnboardingContent"
import * as Yup from "yup";

const DEFAULT_VALUES = {
  isEdit: false,
  app_built: "get_started",
  app_built_notes: "",
  json_file: "",
  aab_file: "",
  create_push_key: false,
  setup_firebase: false,
  add_ios_admins: false,
  upload_ios_app: false,
  media_metadata: {},
  in_app_name: "",
  app_icon_name: "",
  apple_dev_email: "",
  apple_dev_password: "",
  google_dev_email: "",
  google_dev_password: "",
  added_in_appexperts: false,
  ios_push_key_id: "",
  ios_team_id: "",
  ios_p8_file: "",
  app_designed_assets_download_url: ""
}

const onboardingAppBuilt = ({ handleSubmit, initialValues }) => {
  console.log(initialValues?.app_data?.app_token, initialValues?.app?.id,'asdasdsada')
  const fields = [
    {
      component: "app_id",
      name: "app_id",
      label: "App ID",
      placeholder: "",
      isFieldRow: true,
      required: false,
      disabled: true,
    },
    {
      component: "app_token",
      name: "app_token",
      label: "App Token",
      placeholder: "",
      isFieldRow: true,
      required: false,
      disabled: true,
    },
    {
      component: "app_built",
      name: "app_built",
      label: "Status",
      placeholder: "",
      isFieldRow: true,
      required: false,
      disabled: true,
    },
    {
      component: "in_app_name",
      field: "text",
      name: "in_app_name",
      label: "In-App Name",
      placeholder: "",
      isFieldRow: true,
      required: false,
      disabled: true
    },
    {
      component: "app_icon_name",
      field: "text",
      name: "app_icon_name",
      label: "App Icon Name",
      placeholder: "",
      isFieldRow: true,
      required: false,
      disabled: true
    },
    {
      component: "app_designed_assets_download_url",
      name: "app_designed_assets_download_url",
      label: "App Assets",
      placeholder: "",
      isFieldRow: true,
      required: false,
    },
    {
      component: "apple_dev_email",
      name: "apple_dev_email",
      label: "Apple Developer Email",
      placeholder: "",
      isFieldRow: true,
      required: false,
    },
    {
      component: "apple_dev_password",
      name: "apple_dev_password",
      label: "Apple Password",
      placeholder: "",
      isFieldRow: true,
      required: false,
    },
    {
      component: "google_dev_email",
      name: "google_dev_email",
      label: "Google Firebase/Android Gmail",
      placeholder: "",
      isFieldRow: true,
      required: false,
    },
    {
      component: "google_dev_password",
      name: "google_dev_password",
      label: "Google Gmail Password",
      placeholder: "",
      isFieldRow: true,
      required: false,
    },
    {
      component: "added_in_appexperts",
      field: "tickbox",
      name: "added_in_appexperts",
      label: "Apps of Expert Listing",
      placeholder: "",
      isFieldRow: true,
      required: false,
      className: "pl-6 -mt-2.5 pb-2.5",
    },
    {
      component: "ios_push_key_id",
      field: "text",
      name: "ios_push_key_id",
      label: "iOS Push Key ID",
      placeholder: "",
      isFieldRow: true,
      required: false,
    },
    {
      component: "ios_team_id",
      field: "text",
      name: "ios_team_id",
      label: "iOS Team ID",
      placeholder: "",
      isFieldRow: true,
      required: false,
    },
    {
      component: "ios_p8_file",
      name: "ios_p8_file",
      label: "iOS .p8 File Upload",
      placeholder: "",
      isFieldRow: true,
      required: false,
    },
    {
      component: "json_file",
      name: "json_file",
      label: "Firebase Key .json File Upload",
      placeholder: "",
      isFieldRow: true,
      required: false,
    },
    {
      component: "aab_file",
      name: "aab_file",
      label: "Android .aab File Upload",
      placeholder: "",
      isFieldRow: true,
      required: false,
    },
    {
      component: "app_built_notes",
      field: "textarea",
      name: "app_built_notes",
      label: "Notes",
      placeholder: "",
      isFieldRow: true,
      rows: 10,
      required: false,
    },
    {
      component: "setup_firebase",
      field: "tickbox",
      name: "setup_firebase",
      label: "Configure Firebase",
      required: false,
    },
    {
      component: "create_push_key",
      field: "tickbox",
      name: "create_push_key",
      label: "Create iOS Push Key",
      required: false,
    },
    {
      component: "add_ios_admins",
      field: "tickbox",
      name: "add_ios_admins",
      label: "Add iOS Admins",
      required: false,
    },
    {
      component: "upload_ios_app",
      field: "tickbox",
      name: "upload_ios_app",
      label: "Upload iOS App",
      required: false,
    },
  ]

  const schema = {
    app_built: Yup.string(),
    in_app_name: validations.short_text,
    app_icon_name: validations.short_text,
    apple_dev_email: validations.email_not_required,
    apple_dev_password: validations.long_text,
    google_dev_email: validations.email_not_required,
    google_dev_password: validations.long_text,
    added_in_appexperts: Yup.boolean(),
    ios_push_key_id: validations.long_text.max(65535, "Maximum 65535 Characters"),
    ios_team_id: validations.long_text.max(65535, "Maximum 65535 Characters"),
    ios_p8_file: validations.long_text,
    json_file: validations.long_text,
    aab_file: validations.long_text,
    app_built_notes: validations.long_text.max(65535, "Maximum 65535 Characters"),
    setup_firebase: Yup.boolean(),
    create_push_key: Yup.boolean(),
    add_ios_admins: Yup.boolean(),
    upload_ios_app: Yup.boolean(),
  };

  const handleFormatPayload = (values) => {
    const { isEdit, ...rest } = values

    const newPayload = {
      onboarding: {
        ...rest,
      }
    }

    return newPayload
  }

  // reformat data if components used vs payload data is different
  // if you didnt change payload response, skip this and just pass values to defaultValues props
  const formatDefaultValues = () => {
    if (initialValues?.app?.id) {

      const newPayload = {
        ...DEFAULT_VALUES,
        in_app_name: initialValues?.app_data?.about?.store?.in_app_name,
        app_icon_name: initialValues?.app_data?.about?.store?.app_icon_name,
        app_designed_assets_download_url: initialValues?.onboarding?.app_designed_assets_download_url,
        app_designed_assets_file: initialValues?.onboarding?.app_designed_assets_file,
        apple_dev_email: initialValues?.onboarding?.apple_dev_email,
        apple_dev_password: initialValues?.onboarding?.apple_dev_password,
        google_dev_email: initialValues?.onboarding?.google_dev_email,
        google_dev_password: initialValues?.onboarding?.google_dev_password,
        added_in_appexperts: initialValues?.onboarding?.added_in_appexperts,
        ios_push_key_id: initialValues?.onboarding?.ios_push_key_id,
        ios_team_id: initialValues?.onboarding?.ios_team_id,
        ios_p8_file: initialValues?.onboarding?.ios_p8_file,
        app_built: initialValues?.onboarding?.app_built,
        app_built_notes: initialValues?.onboarding?.app_built_notes,
        json_file: initialValues?.onboarding?.json_file,
        aab_file: initialValues?.onboarding?.aab_file,
        create_push_key: initialValues?.onboarding?.create_push_key,
        setup_firebase: initialValues?.onboarding?.setup_firebase,
        add_ios_admins: initialValues?.onboarding?.add_ios_admins,
        upload_ios_app: initialValues?.onboarding?.upload_ios_app,
        media_metadata: initialValues?.onboarding?.media_metadata,
        app_id: initialValues?.app?.id,
        app_token: initialValues?.app_data?.app_token
      }

      return newPayload
    }

    return DEFAULT_VALUES
  }

  return {
    config: {
      label: "Onboarding - App Built",
      resourceEndpoint: "apps",
      columnsMetadata: [
        { customComponent: (
          <OnboardingContent
            title="App Built"
            defaultValues={formatDefaultValues()}
            schema={schema}
            fields={fields}
            handleSubmit={handleSubmit}
            handleFormatPayload={handleFormatPayload}
          />
        ) },
      ],
    }
  }
}

export default onboardingAppBuilt;